// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"83fd1fdd","453":"5aae0d0b"}[chunkId] + ".chunk.js";
};